import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@mui/material";

export default function QcCustomerResponsibilitiesSection({
  mode = "edit",
  value = {
    sanitation1: "",
    sanitation2: "",
    sanitation3: "",
    sealing: "",
    barriers: "",
    repairsMaintenance: "",
    renovation: "",
  },
  onChange,
}) {
  const readOnly = mode === "view";

  const handleFieldChange = (field) => (e) => {
    if (readOnly || !onChange) return;
    onChange(field, e.target.value);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Card variant="outlined" sx={{ mb: 2 }}>
          <CardHeader
            title={
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", textTransform: "uppercase" }}
              >
                Customer's Responsibilities
              </Typography>
            }
            sx={{ pb: 0, px: 2, pt: 2 }}
          />

          <CardContent sx={{ px: 2, pb: 2 }}>
            {/* SANITATION */}
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                Sanitation
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                Needs improvement (Specify area)
              </Typography>

              <Grid container spacing={1.5}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Specify area 1"
                    value={value.sanitation1 || ""}
                    onChange={handleFieldChange("sanitation1")}
                    disabled={readOnly}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Specify area 2"
                    value={value.sanitation2 || ""}
                    onChange={handleFieldChange("sanitation2")}
                    disabled={readOnly}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Specify area 3"
                    value={value.sanitation3 || ""}
                    onChange={handleFieldChange("sanitation3")}
                    disabled={readOnly}
                  />
                </Grid>
              </Grid>
            </Box>

            <Divider sx={{ my: 2 }} />

            {/* RODENT ENTRY POINT */}
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                Rodent Entry Point
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                Needs improvement (Specify area)
              </Typography>

              <Grid container spacing={1.5}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Sealing"
                    value={value.sealing || ""}
                    onChange={handleFieldChange("sealing")}
                    disabled={readOnly}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Barriers"
                    value={value.barriers || ""}
                    onChange={handleFieldChange("barriers")}
                    disabled={readOnly}
                  />
                </Grid>
              </Grid>
            </Box>

            <Divider sx={{ my: 2 }} />

            {/* OTHER */}
            <Box>
              <Grid container spacing={1.5}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Repairs & Maintenance (Specify area)"
                    value={value.repairsMaintenance || ""}
                    onChange={handleFieldChange("repairsMaintenance")}
                    disabled={readOnly}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Renovation"
                    value={value.renovation || ""}
                    onChange={handleFieldChange("renovation")}
                    disabled={readOnly}
                  />
                </Grid>
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}